import _taggedTemplateLiteral from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  animation: rotate 1s linear infinite;\n\n  & .path {\n    stroke: currentColor;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite;\n  }\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 150;\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -35;\n    }\n    100% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -124;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from "../../styled";
import { themeLss } from "../../lss";
/**
 * Default spinner
 */

export var Spinner = styled.svg.attrs(function (props) {
  return {
    themeLss: themeLss,
    children: React.createElement("circle", {
      className: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: "2"
    }),
    viewBox: '0 0 50 50',
    width: props.size === 'lg' ? 50 : props.size === 'sm' ? 20 : 25
  };
})(_templateObject());
Spinner.defaultProps = {
  size: 'md'
};